import client from '../httpClient';

const libraryGetInterruptedApi = (pathParameter, type) => {
  return client.get(`/libraries/interruption/${pathParameter}?sendTypeCode=${type}`);
};

export default libraryGetInterruptedApi;
